export function getDatePart(timestamp, timezone) {
  if (timestamp === null || timestamp === undefined || timestamp === '') return '-'
  return String(timezone ? this.$formatTimestamp(timestamp, false, '', timezone) : this.$formatTimestamp(timestamp)).slice(0, 10)
}
export function getTimePart(timestamp, timezone) {
  if (timestamp === null || timestamp === undefined || timestamp === '') return '-'
  return String(timezone ? this.$formatTimestamp(timestamp, false, '', timezone) : this.$formatTimestamp(timestamp)).substring(11)
}



// WEBPACK FOOTER //
// ./src/utils/dateParts.js